__turbopack_context__.v({
  "content": "Vbb5WW_content",
  "fadeIn": "Vbb5WW_fadeIn",
  "formWrapper": "Vbb5WW_formWrapper",
  "loadingOverlay": "Vbb5WW_loadingOverlay",
  "sending": "Vbb5WW_sending",
  "success": "Vbb5WW_success",
  "successDescription": "Vbb5WW_successDescription",
  "successIcon": "Vbb5WW_successIcon",
  "successTitle": "Vbb5WW_successTitle",
});
